import tippy from "tippy.js";

const tooltipsWrap = document.querySelector(".js-payment-labels-tooltips-init");

if (tooltipsWrap) {
    window.addEventListener("load", () => initPaymentLabelsTooltips(tooltipsWrap));
}

function initPaymentLabelsTooltips(tooltipsWrap) {
    const tooltips = tooltipsWrap.querySelectorAll("[data-tooltip-target]");

    if (tooltips) {
        tooltips.forEach((tooltip) => {
            tippy(tooltip, {
                arrow: true,
                placement: "top",
                maxWidth: 253,
                allowHTML: true,
                theme: "light",
                appendTo: () => document.body,
                trigger: "mouseenter",
                content: tooltip.querySelector("[data-tooltip-content]"),
            });
        });
    }
}
